import { SVG, SVGProps } from './svg'

export function IconMenuClose(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M17.9 16.4a.5.5 0 010 .7l-.8.7a.5.5 0 01-.7 0L12 13.4l-4.4 4.4a.5.5 0 01-.8 0l-.6-.7a.5.5 0 010-.7l4.4-4.4-4.4-4.4a.5.5 0 010-.8l.6-.7a.5.5 0 01.8 0l4.4 4.5L16.4 6a.5.5 0 01.8 0l.7.7a.5.5 0 010 .8L13.4 12l4.5 4.4z" />
    </SVG>
  )
}
